import * as React from 'react';
import * as styles from './ContactButtons.css';

interface IContactButtonsProps {
  callbackButton: React.ReactNode;
  callButton: React.ReactNode;
}

export function ContactButtons({ callbackButton, callButton }: IContactButtonsProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['call']}>{callButton}</div>

      <div className={styles['callback']}>{callbackButton}</div>
    </div>
  );
}
